module.exports = __webpack_public_path__ + "img/background.c9cce11c.png";